import React, { useState } from "react";
import JobCoachAssignmentList from "./JobCoachAssignmentList";
import CreateJobCoachAssignmentForm from "./CreateJobCoachAssignmentForm";
import EditJobCoachAssignmentForm from "./EditJobCoachAssignmentForm";

const JobCoachAssignmentPage = () => {
  const [activeTab, setActiveTab] = useState("list");
  const [editingAssignment, setEditingAssignment] = useState(null);
  const [message, setMessage] = useState("");

  const handleEditClick = (assignment) => {
    setEditingAssignment(assignment);
    setActiveTab("edit");
  };

  const handleBack = () => {
    setEditingAssignment(null);
    setActiveTab("list");
  };

  const handleMessage = (msg) => {
    setMessage(msg);
    setActiveTab("list");
    setEditingAssignment(null);
    setTimeout(() => setMessage(""), 4000);
  };

  const getTitle = () => {
    if (activeTab === "edit") return "Edit Job Coach Assignment";
    if (activeTab === "create") return "Assign a Job Coach to a Consumer";
    return "Assigned Job Coaches";
  };

  return (
    <div className="container mt-4">
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => {
              setEditingAssignment(null);
              setActiveTab("list");
            }}
          >
            View Assignments
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "create" ? "active" : ""}`}
            onClick={() => {
              setEditingAssignment(null);
              setActiveTab("create");
            }}
          >
            Assign Job Coach
          </button>
        </li>
      </ul>

      <h5 className="mb-2">{getTitle()}</h5>
      {message && <div className="alert alert-success">{message}</div>}

      {activeTab === "list" && (
        <JobCoachAssignmentList onEdit={handleEditClick} />
      )}

      {activeTab === "create" && (
        <CreateJobCoachAssignmentForm
          onSuccess={() => handleMessage("Job Coach assigned successfully.")}
        />
      )}

      {activeTab === "edit" && editingAssignment && (
        <EditJobCoachAssignmentForm
          assignment={editingAssignment}
          onBack={handleBack}
          onSuccess={() => handleMessage("Assignment updated successfully.")}
        />
      )}
    </div>
  );
};

export default JobCoachAssignmentPage;
